import React from "react";

/*export default ({ data }) => {
  return (
    <embed src={data.src} quality="high" bgcolor="#ffffff" 
        width="550" height="185" name="paintlogo" align="middle" allowScriptAccess="sameDomain" allowFullScreen="false" 
        type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" />
      <div>{this.props.src}</div>
  );
};*/

class Flash extends React.Component {
  render() {
      var isPowerful = this.props.wmode == "direct";
      var wmode = this.props.wmode != ""
        ? <param name="wmode" value={this.props.wmode}/> 
        : <param name="wmode"/>;
      var fullscreen = <param name="allowFullScreenInteractive" value={isPowerful} />;
    return (
<object width={this.props.w} height={this.props.h} id="movie_name">
    <param name="movie" value={this.props.src}/>
    <param name="quality" value="high" />
    {wmode}
    {fullscreen}
    <object type="application/x-shockwave-flash" data={this.props.src} width={this.props.w} height={this.props.h}>
        <param name="movie" value={this.props.src}/>
        <param name="quality" value="high" />
        {wmode}
        {fullscreen}
        {/*<a href="http://www.adobe.com/go/getflash" style={{fontSize:"220%" }}>
            Play {this.props.title}
                    <p style={{ fontSize: "75%" }}>if you have Flash Player working</p>
        </a>*/}
                <div style={{ fontSize: "175%" }}>
                    <p>You can play the game if you have Flash Player working. </p>
                    <p>Or <a href="/games/3-pandas">Play 3 Pandas</a> HTML game</p>
                </div>
    </object>
</object>        
        
        
        /*<embed src={this.props.src} quality="high" bgcolor="#ffffff" 
        width={this.props.w} height={this.props.h} name="paintlogo" align="middle" allowScriptAccess="sameDomain" allowFullScreen="false" 
        type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" />*/
    )
  }
}
module.exports = Flash;


// WEBPACK FOOTER //
// ./src/templates/flash.js